import { render } from "./OPINION_CREATED_BY_MEMBER.vue?vue&type=template&id=62e55048"
import script from "./OPINION_CREATED_BY_MEMBER.vue?vue&type=script&lang=js"
export * from "./OPINION_CREATED_BY_MEMBER.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__